import { Component, input, output, computed, effect, inject, signal } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Kanban } from '../../../../_services/kanban/kanban.model'
import { DialogComponent, Tab, TabsComponent } from '@visio-ai/ui-kit'
import { KanbanService } from '../../kanban.service'
import { FieldConfig } from '../../entities/kanban-card/kanban-card.component'
import { CardHistoryComponent } from '../../features/card-history/card-history.component'
import { CardFormSubmissionsComponent } from '../../features/card-form-submissions/card-form-submissions.component'
import dayjs from 'dayjs'

@Component({
  selector: 'app-card-details-dialog',
  standalone: true,
  imports: [CommonModule, DialogComponent, TabsComponent, CardHistoryComponent, CardFormSubmissionsComponent],
  templateUrl: './card-details-dialog.component.html',
  styleUrl: './card-details-dialog.component.scss'
})
export class CardDetailsDialogComponent {
  private kanbanService = inject(KanbanService)

  constructor() {
    effect(() => {
      this.card()
      this.selectedTab.set(this.baseTabs[0])
    })
  }

  private baseTabs: Tab[] = [
    {
      name: 'Detalhes',
      value: 'details',
      icon: 'info'
    },
    {
      name: 'Histórico',
      value: 'history',
      icon: 'history'
    }
  ]

  tabs = computed<Tab[]>(() => {
    const board = this.kanbanService.board()
    const hasFormPhases = board?.phases.some(p => p.formSchema && p.formSchema.length > 0)
    if (hasFormPhases) {
      return [
        ...this.baseTabs,
        { name: 'Formulários', value: 'forms', icon: 'description' }
      ]
    }
    return this.baseTabs
  })

  selectedTab = signal<Tab>({ name: 'Detalhes', value: 'details', icon: 'info' })

  card = input.required<Kanban.Card.Entity>()
  showDialog = input.required<boolean>()
  fieldsConfig = input<FieldConfig[]>()

  showDialogChange = output<boolean>()

  tags = computed(() =>
    this.card().tags.flatMap(tag => {
      const tagLabel = this.kanbanService.board()?.tags.find(t => t.id === tag.tagId)
      return tagLabel?.label || []
    })
  )

  cardPhaseName = computed(() => {
    return this.kanbanService.getPhaseName(this.card().phaseId)
  })

  cardFields = computed(() => {
    return this.card().fields.map(field => {
      const fieldConfig = this.fieldsConfig()?.find(f => f.id === field.fieldId)
      const fieldLabel = this.kanbanService.board()?.fields.find(f => f.id === field.fieldId)
      const fieldPipe = fieldConfig?.pipe || ((value: any) => value)
      return {
        ...field,
        label: fieldLabel?.label,
        value: fieldPipe(field.value) || 'N/A'
      }
    })
  })

  cardCreatedAt = computed(() => {
    return dayjs(this.card().createdAt).format('DD/MM/YYYY HH:mm:ss')
  })

  onCloseDialog(): void {
    this.showDialogChange.emit(false)
  }
}
